"use strict";
exports.__esModule = true;
exports.NodeDefExpressionFactory = exports.NodeDefType = void 0;
var utils_1 = require("../utils");
var NodeDefType;
(function (NodeDefType) {
    NodeDefType["boolean"] = "boolean";
    NodeDefType["code"] = "code";
    NodeDefType["coordinate"] = "coordinate";
    NodeDefType["date"] = "date";
    NodeDefType["decimal"] = "decimal";
    NodeDefType["entity"] = "entity";
    NodeDefType["file"] = "file";
    NodeDefType["integer"] = "integer";
    NodeDefType["taxon"] = "taxon";
    NodeDefType["text"] = "text";
    NodeDefType["time"] = "time";
})(NodeDefType = exports.NodeDefType || (exports.NodeDefType = {}));
exports.NodeDefExpressionFactory = {
    createInstance: function (params) {
        var applyIf = params.applyIf, expression = params.expression;
        return { applyIf: applyIf, expression: expression, uuid: utils_1.UUIDs.v4() };
    }
};
//# sourceMappingURL=nodeDef.js.map